export const modifyPlayerPositionForDoubles = (playerPosition: number[][], scorer: string, servingSide: string) => {
    if (servingSide === scorer) {
        if (servingSide === 'left') {
            return [[playerPosition[0][1], playerPosition[0][0]], playerPosition[1]];
        }
        return [playerPosition[0], [playerPosition[1][1], playerPosition[1][0]]];
    }
    return playerPosition;
};

export const determinePlayerPositionForSingles = (playerPosition: number[][], scorer: string, score: number[]) => {
    const playersLeft = playerPosition[0].filter((player) => player !== -1);
    const playersRight = playerPosition[1].filter((player) => player !== -1);
    if (playersLeft.length > 1 || playersRight.length > 1) {
        throw new Error('Something went horrible wrong in the game configuration. Singles should have only one player');
    }
    const playerLeft = playersLeft[0];
    const playerRight = playersRight[0];

    const pointsToConsider = scorer === 'left' ? score[0] : score[1];
    if (pointsToConsider % 2 === 0) {
        return [[-1, playerLeft], [playerRight, -1]];
    } else {
        return [[playerLeft, -1], [-1, playerRight]];
    }
};